const product_US_Locale = {
    'product.text_title1': 'Full-Stack',
    'product.text_title2': 'Ultrasound',
    'product.text_title3': 'Solutions',
    'product.swiperCenter1_1': 'Professional Annotation',
    'product.swiperCenter1_2': 'Efficient and Convenient',
    'product.swiperCenter2_1': 'Inseparable Shadows',
    'product.swiperCenter2_2': 'Rebirth of Intelligence with AI',
    'product.swiperCenter3_1': 'Intelligent Respect for Women',
    'product.swiperCenter4_1': 'Medical Technology Assistant',
    'product.swiperCenter4_2': 'Provide More Intelligent Guidance',
    'product.swiperCenter5_1': 'The Piercing Eyes',
    'product.swiperCenter5_2': 'No "Nodule" Left Hidden',
    'product.swiperCenter6_1': 'Guarding Your Health',
    'product.swiperCenter6_2': 'Ensuring Safety',
    'product.swiperCenter7_1': 'More Than a Heartbeat',
    'product.swiperCenter7_2': 'AI Embraces Love',
    'product.swiperCenter8_1': 'Smart Ultrasound for Reproduction',
    'product.swiperCenter8_2': 'Empowering the Future',
    'product.swiperCenter9_1': 'Ultrasound Quality Control Digital',
    'product.swiperCenter9_2': 'Intelligence Empowerment',
    'product.menuTitle1': 'Medical Image Annotation Software',
    'product.menuTitle2': 'Al For Fetal Ultrasound Scan',
    'product.menuTitle3': 'AI For Pelvic Ultrasound Scan',
    'product.menuTitle4': 'Al For Hip Joint Ultrasound Scan',
    'product.menuTitle5': 'Al For Breast Ultrasound Scan',
    'product.menuTitle6': 'Al For Thyroid Ultrasound Scan',
    'product.menuTitle7': 'Al For Cardiac Ultrasound Scan',
    'product.menuContent7': 'Al For Cardiac Ultrasound Scan',
    'product.menuTitle8': 'Al For Follicle Ultrasound Scan',
    'product.menuContent8': 'Al For Follicle Ultrasound Scan',
    'product.menuTitle9': 'Intelligent Quality Control Platform',
}
export default product_US_Locale
